import { useState, type ReactNode } from "react";
import { BOT_URL } from "@/shared/content.js";
import { uz } from "@/shared/i18n/uz.js";
import { Container } from "@/shared/ui/index.js";
import { Link, useRouter, type Route } from "./router.js";

const NAV: { route: Route; label: string }[] = [
  { route: { name: "home" }, label: uz.nav.home },
  { route: { name: "posts" }, label: uz.nav.posts },
  { route: { name: "winners" }, label: uz.nav.winners },
];

/** Sayt karkasi: yuqorida navigatsiya, pastda pastki qism. */
export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function Header() {
  const { route } = useRouter();
  const [open, setOpen] = useState(false);

  const isActive = (target: Route) =>
    target.name === route.name || (target.name === "posts" && route.name === "post");

  return (
    <header className="bg-night text-night-ink">
      <Container className="flex items-center gap-4 py-3.5">
        <Link to={{ name: "home" }} className="flex items-center gap-2.5">
          {/* Vektor: 34 px da ham qalqon va "HL" o'qiladi. */}
          <img src="/logo.svg" alt="Hovli Liga" width={34} height={34} />
          <span className="font-cond text-lg leading-none font-bold tracking-wide">
            {uz.brand}
          </span>
        </Link>

        <nav className="ml-auto hidden items-center gap-1 sm:flex">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.route}
              className={`rounded-lg px-3 py-2 text-sm transition ${
                isActive(item.route)
                  ? "text-gold"
                  : "text-night-hint hover:text-night-ink hover:bg-night-2"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={BOT_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="bg-gold text-night ml-2 rounded-lg px-3.5 py-2 text-sm font-semibold transition hover:brightness-105"
          >
            {uz.nav.open}
          </a>
        </nav>

        <button
          type="button"
          aria-expanded={open}
          aria-label={uz.nav.home}
          onClick={() => setOpen((value) => !value)}
          className="border-night-line ml-auto rounded-lg border p-2 sm:hidden"
        >
          <svg viewBox="0 0 20 20" className="h-5 w-5" stroke="currentColor" strokeWidth="1.6">
            <path d="M3.5 6h13M3.5 10h13M3.5 14h13" strokeLinecap="round" />
          </svg>
        </button>
      </Container>

      {open ? (
        <Container className="border-night-line flex flex-col gap-1 border-t py-2 sm:hidden">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.route}
              className={`rounded-lg px-3 py-2.5 ${
                isActive(item.route) ? "text-gold" : "text-night-hint"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <a
            href={BOT_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="bg-gold text-night mt-1 rounded-lg px-3 py-2.5 text-center font-semibold"
          >
            {uz.nav.open}
          </a>
        </Container>
      ) : null}
    </header>
  );
}

function Footer() {
  return (
    <footer className="bg-night text-night-hint mt-20">
      <Container className="flex flex-col gap-4 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <img src="/logo.svg" alt="Hovli Liga" width={40} height={40} />
          <div>
            <p className="font-cond text-night-ink text-lg font-bold tracking-wide">{uz.brand}</p>
            <p className="mt-0.5 text-sm">{uz.footer.rights}</p>
          </div>
        </div>

        <a
          href={BOT_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="text-gold text-sm font-medium hover:brightness-110"
        >
          {uz.footer.bot}
        </a>
      </Container>
    </footer>
  );
}
